import get from "lodash-es/get"

export function useMultipleDevicesString(productData: any) {
  const devices = get(productData, "devices", [])
  if (!devices || devices.length === 0) return undefined
  const names = devices.map((d: any) => d?.name).filter(Boolean)
  if (names.length <= 1) return names[0]
  // join with " # " because the PDP expects that format downstream
  return names.join("#")
}
